module.exports = __webpack_public_path__ + "0b4c8c79e2b40400517fc3e74344cac6.pdf";